export class Environment {
  assert() {}

  async() {}

  reportUncaughtRejection() {}

  defer() {}

  globalDebuggingEnabled() {}

}